export async function requestSmsCode(phone: string): Promise<Res<captchaRes>> {
  return http.post('/v1/auth/send_sms_code', {
    phone
  })
}
